import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useLang } from "../../contexts/LanguageContext";
import PageHero from "../../components/public/PageHero";
import { usePageSeo, htmlToText } from "../../components/public/seo/PageSeo";
import { ArrowLeft } from "lucide-react";

export default function NoticiaDetail() {
  const { slug } = useParams();
  const { pick, t, lang } = useLang();
  const [item, setItem] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/news/${slug}`).then((r) => setItem(r.data)).catch(() => setError(true));
  }, [slug]);

  usePageSeo(item ? {
    title: `${pick(item, "title")} · CECIT`,
    description: pick(item, "meta_description") || pick(item, "excerpt") || htmlToText(pick(item, "body")),
    image: item.cover_image || null,
    type: "article",
  } : null);

  if (error) return <div className="min-h-[50vh] flex items-center justify-center text-gray-500">404</div>;
  if (!item) return <div className="min-h-[50vh] flex items-center justify-center text-gray-400">…</div>;

  return (
    <div data-testid={`noticia-detail-${slug}`}>
      <PageHero title={pick(item, "title")} subtitle={pick(item, "excerpt")} image={item.cover_image} />
      <article className="max-w-3xl mx-auto px-6 py-20">
        <Link to="/noticias-socios" className="inline-flex items-center gap-2 text-sm text-[#0F2040] hover:text-[#C8102E] mb-8">
          <ArrowLeft className="w-4 h-4" /> {t("common.back")}
        </Link>
        {item.tag && <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#C8102E]">{item.tag}</span>}
        <p className="text-sm text-gray-500 mt-3 mb-8">
          {new Date(item.published_at).toLocaleDateString(lang === "es" ? "es-ES" : "fr-FR", { dateStyle: "long" })}
        </p>
        <div className="prose-cecit text-gray-700 leading-relaxed text-lg">
          {pick(item, "body").split(/\n\n+/).map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </article>
    </div>
  );
}
